<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
    <div>
        <CopyDistPointsModal/>
        <v-container>
            <v-row>
                <v-col>
                    <v-card class="elevation-6">
                        <v-row>
                            <v-col class="pb-0">
                                <v-card-title>
                                    <span class="title text--primary ml-3">
                                        Επιλεγμένα Συγγράμματα
                                    </span>
                                    <v-spacer></v-spacer>
                                    <v-tooltip top v-if="$store.getters.homePageInformation.type != 'Allocator'">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn class="ml-1" v-on="on"
                                                   :loading="$store.getters.publisherSelectedBooksXlsx.isLoading"
                                                   @click="getReport"
                                                   small fab
                                                   color="primary"><v-icon large color="white">get_app</v-icon></v-btn>
                                        </template>
                                        <span>Λίστα Επιλεγμένων Βιβλίων από Γραμματείες</span>
                                    </v-tooltip>
                                    <v-tooltip left v-if="$store.getters.homePageInformation.type != 'Allocator'">
                                        <template v-slot:activator="{ on, attrs }">
                                            <v-btn small
                                                   @click="$store.commit('setCopyDistPointsModal', true)"
                                                   class="ml-2"
                                                    fab
                                                   v-on="on"
                                                   outlined>
                                                <v-icon color="teal" large>forward</v-icon>
                                            </v-btn>
                                        </template>
                                        <span>Μεταφορά Σημείων Διανομής</span>
                                    </v-tooltip>
                                </v-card-title>
                                <v-divider></v-divider>
                                <v-card-subtitle class="pb-0" v-if="$store.getters.homePageInformation.type != 'Allocator'">
                                    <v-container class="pb-0">
                                                <v-row>
                                                    <v-col xl="3" lg="4" md="6" sm="6" class="pa-0 mt-2">
                                                        <v-chip-group
                                                                v-model="distPointLabel"
                                                                column
                                                                mandatory>
                                                            <v-chip
                                                                    filter
                                                                    outlined
                                                                    color="teal"
                                                                    value="Όλα">
                                                                Όλα
                                                            </v-chip>
                                                            <v-chip class="ml-2"
                                                                    filter
                                                                    outlined
                                                                    color="teal"
                                                                    value="Χωρίς Σημεία Διανομής">
                                                                Χωρίς Σημεία Διανομής
                                                            </v-chip>
                                                        </v-chip-group>
                                                    </v-col>
                                                    <v-col xl="3" lg="4" md="6" sm="6">
                                                        <v-select :items="$store.getters.years" @change="onAcademicSelectChanged"
                                                                  class="pa-0 ma-0"
                                                                  item-text="label"
                                                                  label="Ακαδημαϊκό Έτος"
                                                                  outlined dense
                                                                  return-object
                                                                  v-model="academicYearSelect">

                                                        </v-select>
                                                    </v-col>
                                                    <v-col xl="3" lg="4" md="8" sm="6">
                                                        <v-select :items="institution" @change="getSelectedBook(true)"
                                                                  class="pa-0 ma-0"
                                                                  item-text="name"
                                                                  label="Επιλέξτε Ίδρυμα"
                                                                  outlined dense
                                                                  return-object
                                                                  v-model="institutionSelected">

                                                        </v-select>
                                                    </v-col>
                                                    <v-col xl="3" lg="4" md="4" sm="6">
                                                        <v-btn @click="getAllOrNoDist()" class="ml-4 mt-1" rounded outlined color="teal">
                                                            Αναζήτηση
                                                            <v-icon color="teal" right dark >search

                                                            </v-icon>
                                                        </v-btn>
                                                    </v-col>
                                                </v-row>
                                    </v-container>
                                </v-card-subtitle>
                                <v-card-subtitle class="pt-0">
                                    <v-row>
                                        <v-col cols="12" lg="4" md="4" sm="4" xs="12">
                                            <v-text-field
                                                    append-icon="search"
                                                    hide-details
                                                    label="Αναζήτηση"
                                                    single-line
                                                    v-model="searchBar"
                                            ></v-text-field>
                                        </v-col>
                                        <v-col lg="2" md="2" sm="2" xs="1">
                                            <v-icon @click="getSemester('Ximerino')" color="blue" large>
                                                fiber_manual_record
                                            </v-icon>
                                            Χειμερινό
                                        </v-col>
                                        <v-col lg="2" md="2" sm="2" xs="1">
                                            <v-icon @click="getSemester('Earino')" color="yellow" large>
                                                fiber_manual_record
                                            </v-icon>
                                            Εαρινό
                                        </v-col>
                                        <v-col lg="2" md="2" sm="2" xs="1">
                                            <v-icon @click="getSemester('Etisio')" color="#4f4d4d" large>
                                                fiber_manual_record
                                            </v-icon>
                                            Ετήσιο
                                        </v-col>
                                        <v-col lg="2" md="2" sm="2" xs="1">
                                            <v-icon @click="getSemester('')" color="#00b058" large>
                                                fiber_manual_record
                                            </v-icon>
                                            Όλα
                                        </v-col>
                                    </v-row>
                                </v-card-subtitle>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col>
                                <v-card class="elevation-2 mx-3" overlined>
                                    <v-data-table
                                            :headers="headers"
                                            :items="customFilter"
                                            :search="searchBar"
                                            class="elevation-1"
                                            item-key="id"
                                            no-data-text="Δεν υπάρχουν δεδομένα."
                                            return-object

                                    >
                                        <template v-slot:item="{ item }">
                                            <tr :class="item.id == selectedBookId ? 'info white--text' : ''">
                                                <td class="text-left d-sm-table-cell d-flex">

                                                    <v-tooltip top v-if="!item.active">
                                                        <template v-slot:activator="{ on, attrs }">
                                                            <v-list-item-avatar color="red"
                                                                                class="ma-0"
                                                                                v-on="on"
                                                                                size="25"
                                                                                ></v-list-item-avatar>
                                                        </template>
                                                        <span>Η επιλογή δεν διανέμεται γι αυτό το μάθημα. Έχει απενεργοποιηθεί από τη γραμματεία.</span>
                                                    </v-tooltip>


                                                    <v-list-item-avatar color="yellow"
                                                                        size="25"
                                                                        v-if="item.course.period ==='Earino' && item.active"></v-list-item-avatar>
                                                    <v-list-item-avatar color="blue"
                                                                        size="25"
                                                                        v-if="item.course.period ==='Ximerino' && item.active">
                                                    </v-list-item-avatar>
                                                    <v-list-item-avatar color="#4f4d4d"
                                                                        size="25"
                                                                        v-if="item.course.period ==='Etisio' && item.active">
                                                    </v-list-item-avatar>
                                                </td>
                                                <td @click="getAction(item)" class="text-left d-sm-table-cell d-flex">{{ item.lastModificationString}}</td>
                                                <td @click="getAction(item)" class="text-left d-sm-table-cell d-flex">{{ item.bookID}}</td>
                                                <td @click="getAction(item)" class="text-left d-sm-table-cell d-flex">{{ item.book.title}}</td>
                                                <td @click="getAction(item)" class="text-left d-sm-table-cell d-flex">{{ item.academic.institution}}</td>
                                                <td @click="getAction(item)" class="text-left d-sm-table-cell d-flex">{{ item.academic.department}}</td>
                                                <td @click="getAction(item)" class="text-left d-sm-table-cell d-flex">{{ item.course.title}}</td>
                                            </tr>
                                        </template>

                                    </v-data-table>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col>
            </v-row>
            <SelectedFullDialog v-if="Object.keys(selectedObj).length > 0" :selectedObj="selectedObj" :academicYearSelect="academicYearSelect"/>
        </v-container>
    </div>
</template>

<script>

    import request from '../../requests'
    import utils from '../../utilities'
    import service from '../../service'
    import SelectedFullDialog from "./SelectedFullDialog";
    import CopyDistPointsModal from "./CopyDistPointsModal";

    export default {
        name: "SelectedBooks",
        components: {CopyDistPointsModal, SelectedFullDialog},
        data: () => ({
            utils,
            selectedBookId: -1,
            distPointLabel: 'Όλα',
            selectedObj: {},
            academicYearSelect: {},
            institutionSelected: {},
            searchBar: '',
            expanded: [],
            codeSearch: '',
            titleSearch: '',
            institutionSearch: '',
            departmentSearch: '',
            subjectSearch: '',
            institution: [],
            search: '',
            toggle_exclusive: undefined,
            semesterToggle: '',
            singleExpand: true,
            dPoints: ['Σημείο 1', 'Σημείο 2', 'Σημείο 3', 'Σημείο 4'],
            headers: [
                {
                    text: 'Περίοδος',
                    align: 'start',
                    value: 'semester',
                },
                {text: 'Τελευταία Ενημέρωση', value: 'lastModification', align: 'center'},
                {text: 'Κωδικός', value: 'bookID', align: 'center'},
                {text: 'Τίτλος', value: 'book.title', align: 'center'},
                {text: 'Ίδρυμα', value: 'academic.institution', align: 'center'},
                {text: 'Τμήμα', value: 'academic.department', align: 'center'},
                {text: 'Μάθημα', value: 'course.title', align: 'center'},
                {text: '', value: 'data-table-expand'}
            ],
        }),
        methods: {

            getAction(item) {

                this.selectedBookId = item.id;
                var courseBooksDistribution = {
                    prefectureID: item.secretariat.secretaryPrefectureID,
                    bookID: item.bookID,
                    courseID: item.course.id
                };
                this.selectedObj = item;

                if (this.$store.getters.homePageInformation.type != 'Allocator') {
                    var token = utils.getLocalStorage('token');
                    if (token != null) {
                        this.$store.commit('setLoadingModal', true);
                        request.getSelectedDistPoints(token, courseBooksDistribution, this.getSelectedDistPoints);
                    } else {
                        this.$store.commit('setloginModal', true);
                    }
                }
                else {
                    this.$store.commit('setSelectedFullDialog', true);
                }
            },

            getSelectedDistPoints(response) {

                this.$store.commit('setSelectedDistPoint', response);
                this.$store.commit('setLoadingModal', false);
                this.$store.commit('setSelectedFullDialog', true);
            },

            //get the report by academic year
            getReport(){
                var year = this.academicYearSelect.value;
                service.startServicePublisherSelectedBooksXlsx(year);

            },

            getSemester(semester) {

                this.searchBar = '';
                this.semesterToggle = semester;

            },

            createSelectedVariables() {

                var years = this.$store.getters.years;

                if (years.length > 0) {
                    this.academicYearSelect = years[0];
                }
                this.onAcademicSelectChanged();
            },

            onAcademicSelectChanged() {

                var year = this.academicYearSelect.value;

                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    if (this.$store.getters.homePageInformation.type != 'Allocator') {
                        request.getInstitution(token, year, this.getInstitutionCallBack);
                    }
                    else {
                        request.getAllocatorSelectedBook(token, this.getAllocatorSelectedBook)
                    }
                } else {
                    this.$store.commit('setloginModal', true);
                }
            },

            getInstitutionCallBack(response) {

                this.institution = [];
                if (response.length > 0) {
                    for (var i = 0; i < response.length; i++) {
                        this.institution.push(response[i])
                    }
                }

                //sort By name
                this.institution.sort((a,b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
                //push All item in 0 position
                this.institution.splice(0, 0, {id: 0, name: 'ΟΛΑ'});
                this.institutionSelected = this.institution[0];
                this.getSelectedBook(false);
            },

            getAllocatorSelectedBook(response) {

                this.$store.commit('setSelectedBook', response);
                this.$store.commit('setLoadingModal', false);
            },

            getAllOrNoDist() {
                let all = this.distPointLabel !== 'Χωρίς Σημεία Διανομής';
                var id;
                if (this.institutionSelected.id === 0) {
                    id = null
                } else {
                    id = this.institutionSelected.id
                }
                var courseBook = {
                    institutionId: id,
                    year: this.academicYearSelect.value,
                    all: all
                };
                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    request.getSelectedBook(token, courseBook, this.getSelectedBookCallBack);
                } else {
                    this.$store.commit('setloginModal', true);
                }
            },

            distOrNotDistPointButton() {
                this.getSelectedBook(true);
                if (this.distPointLabel == 'Χωρίς Σημεία Διανομής') {
                    return this.distPointLabel = 'Όλα'
                }
                return this.distPointLabel =  'Χωρίς Σημεία Διανομής'
            },

            getSelectedBook(onChanged) {

                var all;
                if (this.distPointLabel == 'Όλα') {
                    all = true;
                }
                else {
                    all = false;
                }
                var courseBook = {};
                if (onChanged) {
                    var selectedInstitutionId;
                    if (this.institutionSelected.id == 0) {
                        selectedInstitutionId = null
                    } else {
                        selectedInstitutionId = this.institutionSelected.id
                    }
                    courseBook = {
                        institutionId: selectedInstitutionId,
                        year: this.academicYearSelect.value,
                        all: all
                    };
                } else {
                    courseBook = {
                        institutionId: null,
                        year: this.academicYearSelect.value,
                        all: all
                    };
                }

                var token = utils.getLocalStorage('token');
                if (token != null) {
                    this.$store.commit('setLoadingModal', true);
                    request.getSelectedBook(token, courseBook, this.getSelectedBookCallBack);
                } else {
                    this.$store.commit('setloginModal', true);
                }
            },

            getSelectedBookCallBack(response) {

                for (var i = 0; i < response.length; i++) {
                    response[i].id = i;
                }

                this.$store.commit('setSelectedBook', response);
                this.$store.commit('setLoadingModal', false);
            }
        },
        computed: {
            filteredBySemester: function () {
                return this.books.filter((book) => {
                    if (this.searchBar != '') {

                        return book.subject.match(this.searchBar);
                    }
                    return book.semester.match(this.semesterToggle)
                })
            },

            customFilter: function () {

                return this.$store.getters.selectedBook.filter((bookObj) => {

                    if (this.semesterToggle != '') {
                        if (this.semesterToggle != 'No Dist Point') {
                            return bookObj.course.period.match(this.semesterToggle)
                        } else {
                            return !bookObj.distributed
                        }
                    }
                    return bookObj;
                })
            }
        },

        created() {
            window.scrollTo(0, 0);
            this.createSelectedVariables();
        }
    }
</script>

<style scoped>
    .btn {
        text-transform: none;
    }
</style>